import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="parrallax"
export default class extends Controller {
  connect() {
  //   console.log("Parallax controller connected");

  //   // Wait until GSAP and ScrollTrigger are loaded
  //   const waitForGSAP = () => {
  //     if (window.gsap && window.ScrollTrigger) {
  //       gsap.registerPlugin(ScrollTrigger);
  //       this.initParallax();
  //     } else {
  //       setTimeout(waitForGSAP, 50);
  //     }
  //   };

  //   waitForGSAP();
  // }

  // initParallax() {
  //   const images = this.element.querySelectorAll(".parallax-image");

  //   if (images.length === 0) return;

  //   images.forEach(img => {

  //     // const initialOffset =  -img.offsetHeight * 0.2;
  //     const initialOffset = -img.offsetHeight * 0.8
  //     gsap.set(img, { y: initialOffset });

  //     ScrollTrigger.create({
  //       trigger: img,
  //       start: "top bottom",
  //       end: "bottom top",
  //       scrub: true,
  //       invalidateOnRefresh: true,
  //       onUpdate: self => {
  //         const scrollDistance = img.offsetHeight;
  //         gsap.set(img, { y: initialOffset + scrollDistance * self.progress });
  //       }
  //     });
  //   });

  //   window.addEventListener("load", () => ScrollTrigger.refresh());
  }
}
